// TODO: Link Variants?

const Link = {
  baseStyle: {
    color: "primary.400",
  },
};

export default Link;
